"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPLICANT_STUDY_MINOR_CONSENT = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const question_groups_1 = require("../../groups/question-groups");
const form_1 = require("../../utils/form");
exports.APPLICANT_STUDY_MINOR_CONSENT = (0, form_1.form)({
    name: "APPLICANT_STUDY_MINOR_CONSENT",
    title: "Minor consent intake form",
    content: [question_groups_1.QuestionGroup["APPLICANT_STUDY_MINOR_CONSENT"]],
    id: 36,
});
